import {Form, Row, Col, Input, Button} from "antd";
import {MinusCircleOutlined, PlusOutlined} from "@ant-design/icons";
import React from "react";

const ReportYearDef = () => {
    return (
        <>
            <Form.List name="reportYearList">
                {(fields, { add, remove }, { errors }) => (
                    <>
                        {fields.map(({ key, name, ...restField }, index) => (
                            <Row gutter={[20, 0]}>
                                <Form.Item name={[name, 'orderNum']} initialValue={index + 1} hidden>
                                    <Input type="hidden" />
                                </Form.Item>
                                <Col span={7}>
                                    <Form.Item name={[name, 'name']}
                                               rules={[{ required: true, message: 'Missing Report Year' }]}>
                                        <Input placeholder="Report Year" />
                                    </Form.Item>
                                </Col>
                                <Col span={16}>
                                    <Form.Item name={[name, 'description']}>
                                        <Input placeholder="Description" />
                                    </Form.Item>
                                </Col>
                                <Col span={1} style={{ paddingTop: '5px', paddingLeft: '-5px'}}>
                                    <MinusCircleOutlined style={{ color: "red" }} onClick={() => remove(name)} />
                                </Col>
                            </Row>
                        ))}
                        <Form.Item>
                            <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}> Add </Button>
                        </Form.Item>
                        <Form.ErrorList errors={errors} />
                    </>
                )}
            </Form.List>
        </>
    )
}

export default ReportYearDef;